import { render } from "./RequestCheck.view.vue?vue&type=template&id=4bbbaba8"
import script from "./RequestCheck.view.vue?vue&type=script&lang=js"
export * from "./RequestCheck.view.vue?vue&type=script&lang=js"

import "./RequestCheck.view.vue?vue&type=style&index=0&id=4bbbaba8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__